document.addEventListener("DOMContentLoaded", function() {
  // Get all the link elements
  const links = document.querySelectorAll(".sticky__nav-link");
  let lastActiveLink = null;
  const currentItemDiv = document.querySelector(".sticky__current-item");

  // Function to check if the entire element is in viewport
  function isElementFullyInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // Function to handle scroll event
  function onScroll() {
    let newActiveLink = null;
    links.forEach(link => {
      const targetId = link.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement && isElementFullyInViewport(targetElement)) {
        newActiveLink = link;
      }
    });

    if (newActiveLink && newActiveLink !== lastActiveLink) {
      if (lastActiveLink) {
        lastActiveLink.classList.remove("active");
      }
      lastActiveLink = newActiveLink;
      lastActiveLink.classList.add("active");
      currentItemDiv.textContent = lastActiveLink.textContent;
    }
  }

  // Function to set initial state
  function setInitialState() {
    const firstLink = links[0];
    firstLink.classList.add("active");
    currentItemDiv.textContent = firstLink.textContent;
  }

  // Attach scroll event listener
  window.addEventListener("scroll", onScroll);

  // Set initial state
  setInitialState();
});

window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY;
    var stickyDiv = document.querySelector('.sticky');

    if (window.innerWidth <= 959) {
        if (scrollPosition > 50) {
            stickyDiv.classList.add('visible');
        } else {
            stickyDiv.classList.remove('visible');
        }

    } else {
        // Reset styles if viewport width is greater than 959px
        stickyDiv.classList.remove('visible');
    }
});

menuIcon.addEventListener('click', function() {
    var menuIcon = document.getElementById('menuIcon');
    var stickyNav = document.querySelector('.sticky__nav');
    stickyNav.classList.toggle('show-nav');
    menuIcon.classList.toggle('opened');
});

// Get all elements with the class "print-link"
var printLinks = document.querySelectorAll('.print-link');

// Loop through each element and attach the click event listener
printLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default link behavior
        window.print(); // Open the print dialogue
    });
});
